import { render } from "./FeeatherEyeSvg.vue?vue&type=template&id=0f3ddfa9"
const script = {}
script.render = render

export default script